import React from 'react';
import { Paper, Box, Typography, Avatar, Rating } from '@mui/material';

interface ReviewCardProps {
  userName: string;
  avatar?: string;
  date: string; // ISO string or formatted date
  rating: number;
  review: string;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ userName, avatar, date, rating, review }) => {
  // Simple date formatting (e.g., Sep 5, 2023)
  const formattedDate = new Date(date).toLocaleDateString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
  });

  return (
    <Paper elevation={0} sx={{ p: 3, mb: 2, borderRadius: 4, bgcolor: 'white' }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Avatar src={avatar} alt={userName} sx={{ width: 34, height: 34,top:30 }} />
        <Box sx={{ flex: 1 }}>
          <Typography variant="caption" color="text.secondary">
            {formattedDate}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 0.5 }}>
            {userName}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {review}
          </Typography>
          <Rating value={rating} readOnly size="small" />
        </Box>
      </Box>
    </Paper>
  );
};

export default ReviewCard; 